/* Breadcrumbs */

var breadcrumbs = $('.wex-breadcrumbs');

if (breadcrumbs.length === 1) {
  var crumbs = breadcrumbs.children('li').length;

  if (crumbs >= 3) {
    breadcrumbs.addClass('wex-breadcrumbs--deep-list');
  }
}